module.exports = __webpack_public_path__ + "static/media/flow.1dcc54af.svg";